import React from 'react'
import styled from 'styled-components'
import SendIcon from '@material-ui/icons/Send';
import {useState} from 'react';
import SelectInput from '@material-ui/core/Select/SelectInput';

function ChatInput({sendMessage}) {

    const [input, inputset ]=useState("");
    const send = (e) =>
    {
        console.log("in send after clicked on button")
        e.preventDefault();
        if(!input) return;
        sendMessage(input)
        inputset("")
    }




    return (
        <Container>
            <InputContainer>
                <form>
                    <input 
                        onChange={(e)=>inputset(e.target.value)}
                        type="text" 
                        value={input}
                        placeholder="Message Here......."/>
                
                    <SendButton type="submit" onClick={send} >
                        <SendIcon/>
                    </SendButton>

                </form>

            
            </InputContainer>
        </Container>
    )
}

export default ChatInput

const Container = styled.div`
    padding-left:20px;
    padding-right:20px;
    padding-bottom:24px;
    align-items:center;
    
`
const InputContainer = styled.div`
    
    border:1px solid #8D8D8E;
    border-radius:4px;
    align-item:center;
    display:flex;
    form{
        width:100%;
        display:flex;
        padding-left:10px;
        height:42px;
        align-item:center;
        input{
            flex:1;
            border:none;
            font-size: 13px;
         
        }
        input:focus{
            outline:none;
        }
    
    }
`
const SendButton = styled.button`
    display:flex;
    align-items:center;
    border-radius:50%;
    justify-content: center;
    margin-right:10px;
    cursor:pointer;
    border:none
    .MuiSvgIcon-root{
        
    }
    
`